import { Extra } from '@sentry/core';
import { ENV } from '@user-portal/helpers';

import {
    DEEP_LINK_ERROR,
    SENTRY_ANALYTIC,
    SENTRY_APP,
    SENTRY_AXIOS,
    SENTRY_CABINET,
    SUBSCRIPTION_ACTION,
} from './consts';

export interface ISentry {
    sentryDSN: string;
    env: ENV;
    release?: string;
    tracesSampleRate?: number;
    autoSessionTracking?: boolean;
}

export interface IError {
    name?: string;
    message?: string;
    code?: string;
    stack?: string;
    value?: { code?: string; message?: string | string[] };
    response?: { status: number; config: { url: string } };
}

export type ErrorType =
    | typeof SENTRY_APP
    | typeof SENTRY_ANALYTIC
    | typeof SENTRY_AXIOS
    | typeof SENTRY_CABINET
    | typeof SUBSCRIPTION_ACTION
    | typeof DEEP_LINK_ERROR;

export type TagsType = [string, string][];

export type ExtrasType = Record<string, Extra>;

export enum ERROR_LEVELS {
    CRITICAL = 'fatal',
    ERROR = 'error',
    WARNING = 'warning',
}
